import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../common/InputField";
import "./CareDirective.scss";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import {
  setCareDirectiveData,
  getCareDirectiveData,
} from "../../../services/documentServices";
import { toast } from "react-hot-toast";
import {
  getUserIdFromLocalStorage,
  setStepStatus,
} from "../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const Clothing = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    clothLike: "",
    clothDislike: "",
    jewellaryDescription: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const validate = Yup.object({
    clothLike: Yup.string().nullable(),
    clothDislike: Yup.string().nullable(),
    jewellaryDescription: Yup.string().nullable(),
  });

  const handleSubmit = async (values) => {
    setButtonDisabled(true);
    const { stepStatus, careDirectiveId, clothId, ...rest } = values;
    const payload = {
      ...data,
      cloth: {
        ...rest,
        careDirectiveId,
        clothId,
        stepStatus: setStepStatus("00-00-0000", { ...rest }),
      },
    };
    const result = await setCareDirectiveData(payload, uID);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleSkipFun = async () => {
    next();
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const getCareDirectiveDataFun = async () => {
    setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getCareDirectiveData(uID);
      if (result?.success) {
        setData(result.payLoad);
        if (result.payLoad.cloth !== null) {
          setInitialValues(result.payLoad.cloth);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setButtonDisabled(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCareDirectiveDataFun();
  }, []);

  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={7}
            md={6}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form id="form_submit" onSubmit={formik.handleSubmit}>
                  <InputLabel sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-tab-2")}
                  </InputLabel>
                  <FormHelperText sx={{ color: "color.magentaDark2" }}>
                    {t("cd-cl-text-1")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="clothLike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-cl-text-2")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="clothDislike"
                    type="text"
                  />
                  <FormHelperText sx={{ mt: 2, color: "color.magentaDark2" }}>
                    {t("cd-cl-text-3")}
                  </FormHelperText>
                  <InputField
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    name="jewellaryDescription"
                    type="text"
                  />
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default Clothing;
